import { gql } from '@apollo/client'

export const CREATE_WEEKLY_AGENDA_REPORT = gql`
  mutation CreateAutomaticJobWeeklySchedule($data: CreateAutomaticJobWeeklyScheduleInput!) {
    createAutomaticJobWeeklySchedule(data: $data) {
      ... on StatusMessage {
        success
        message
      }
      ... on WorkspaceJob {
        id
        isAutomaticallyGenerated
        workspaceId
      }
    }
  }
`

export const CREATE_TREND_ANALYSIS_REPORT = gql`
  mutation CreateAutomaticJobTrendAnalysis($data: CreateAutomaticJobTrendAnalysisInput!) {
    createAutomaticJobTrendAnalysis(data: $data) {
      ... on WorkspaceJob {
        id
        isAutomaticallyGenerated
        workspaceId
      }
      ... on StatusMessage {
        success
        message
      }
    }
  }
`
